import { render, staticRenderFns } from "./MainHero.vue?vue&type=template&id=bf1f4914"
import script from "./MainHero.vue?vue&type=script&lang=js"
export * from "./MainHero.vue?vue&type=script&lang=js"
import style0 from "./MainHero.vue?vue&type=style&index=0&id=bf1f4914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports